import { Router } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

// 路由守卫配置
export function setupRouterGuard(router: Router) {
  // 全局前置守卫
  router.beforeEach(async (to, from, next) => {
    const authStore = useAuthStore()
    
    // 设置页面标题
    document.title = to.meta.title ? `${to.meta.title}` : 'CatParty'
    
    // 检查是否需要登录
    if (to.meta.requiresAuth) {
      // 检查是否已登录
      if (!authStore.isAuthenticated) {
        console.warn('请先登录')
        return next({ name: 'Login', query: { redirect: to.fullPath } })
      }
      
      // 检查权限
      if (to.meta.roles && to.meta.roles.length > 0) {
        const hasPermission = authStore.hasAnyRole(to.meta.roles as string[])
        if (!hasPermission) {
          console.error('没有访问权限')
          return next(from.fullPath || '/')
        }
      }
      
      return next()
    }
    
    // 已登录用户访问登录页时重定向到首页
    if (authStore.isAuthenticated && to.name === 'Login') {
      return next('/')
    }
    
    next()
  })
  
  // 全局后置钩子
  router.afterEach((to, from) => {
    // 可以在这里添加页面访问统计等逻辑
  })
  
  // 错误处理
  router.onError((error) => {
    console.error('路由错误:', error)
  })
}
    